import BlogSection from "@/components/BlogSection";

export default function Blog() {
  return <div style={{ padding: "40px" }}>Blog page works</div>;
}
